(function () {
  "use strict";

  window.UA_CATALOG = window.UA_CATALOG || {};

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function currentCatalogReturnUrl() {
    return (
      window.location.pathname +
      window.location.search +
      window.location.hash
    );
  }

  function productUrl(state, product, color) {
    var base = state.productPageBase || "/pages/product-detail-v2";
    var url;

    try {
      url = new URL(base, window.location.origin);
    } catch (_error) {
      url = new URL("/pages/product-detail-v2", window.location.origin);
    }

    url.searchParams.set("productId", String(product.id || ""));

    if (color && color.styleId) {
      url.searchParams.set("styleId", String(color.styleId));
    } else {
      url.searchParams.delete("styleId");
    }

    if (color && color.name) {
      url.searchParams.set("selectedColor", String(color.name));
    } else {
      url.searchParams.delete("selectedColor");
    }

    url.searchParams.set("returnUrl", currentCatalogReturnUrl());

    return url.pathname + url.search + url.hash;
  }

  function swatchStyle(color) {
    var first = color.hex1 || "#d9dee6";
    var second = color.hex2 || "";

    if (second) {
      return "background:linear-gradient(135deg," + first + " 0 50%," + second + " 50% 100%)";
    }

    return "background:" + first;
  }

  function normalizedProductTags(product) {
    return []
      .concat(Array.isArray(product.tags) ? product.tags : [])
      .concat(Array.isArray(product.curatedTags) ? product.curatedTags : [])
      .map(function (value) {
        return String(value || "")
          .trim()
          .toLowerCase()
          .replace(/[\s-]+/g, "_");
      });
  }

  function productBadgeHtml(product) {
    var tags = normalizedProductTags(product);
    var name = String(product.name || "").toLowerCase();

    var isPackageDeal = tags.some(function (tag) {
      return (
        tag === "curated_package_deals" ||
        tag === "package_deals" ||
        tag === "package_deal" ||
        tag.indexOf("package_") === 0
      );
    });

    var isOnSale =
      tags.some(function (tag) {
        return (
          tag.indexOf("on_sale") >= 0 ||
          tag.indexOf("special_sale") >= 0 ||
          tag.indexOf("close_out") >= 0 ||
          tag.indexOf("clearance") >= 0
        );
      }) ||
      name.indexOf(" sale:") >= 0 ||
      name.indexOf("close out") >= 0;

    var badges = [];

    if (isOnSale) {
      badges.push(
        '<span class="ua-catalog__badge ua-catalog__badge--sale">On Sale</span>'
      );
    }

    if (isPackageDeal) {
      badges.push(
        '<span class="ua-catalog__badge ua-catalog__badge--package">Package Deals</span>'
      );
    }

    if (!badges.length) {
      return "";
    }

    return (
      '<div class="ua-catalog__badges" aria-label="Product labels">' +
      badges.join("") +
      "</div>"
    );
  }

  function normalizedColorToken(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/%20/g, " ")
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");
  }

  function imageColorToken(imageUrl) {
    var value = String(imageUrl || "");
    if (!value) return "";

    try {
      var url = new URL(value, window.location.origin);
      var match = url.pathname.match(
        /\/images\/products\/[^/]+\/products\/[^/]+\/([^/]+)\//i
      );

      return match
        ? normalizedColorToken(decodeURIComponent(match[1]))
        : "";
    } catch (_error) {
      return "";
    }
  }

  function normalizedImageIdentity(imageUrl) {
    var value = String(imageUrl || "");
    if (!value) return "";

    try {
      var url = new URL(value, window.location.origin);

      return url.pathname
        .replace(
          /\/(?:50|75|100|150|200|250|300|400|480|500|600|800|1000|1200|Original)\.png$/i,
          "/IMAGE.png"
        )
        .toLowerCase();
    } catch (_error) {
      return value
        .split("?")[0]
        .replace(
          /\/(?:50|75|100|150|200|250|300|400|480|500|600|800|1000|1200|Original)\.png$/i,
          "/IMAGE.png"
        )
        .toLowerCase();
    }
  }

  function getInitialColor(state, product, colors) {
    if (!Array.isArray(colors) || !colors.length) return null;

    /*
      A selected catalog color filter must take priority over the product's
      default style and thumbnail. Without this, a Teal/Silver/Ash filter can
      return the correct product while the card still displays its default
      Black or Navy image.
    */
    var activeFilterColor = normalizedColorToken(
      state &&
      state.filters &&
      state.filters.color
        ? state.filters.color
        : ""
    );

    var explicitStyleId = String(
      product.defaultStyleId ||
      product.DefaultStyleId ||
      product.styleId ||
      product.StyleId ||
      ""
    );

    var explicitColorName = normalizedColorToken(
      product.defaultColor ||
      product.DefaultColor ||
      product.colorName ||
      product.ColorName ||
      product.selectedColor ||
      ""
    );

    var productImage =
      product.thumbnailUrl ||
      product.imageUrl ||
      product.ImageUrl ||
      "";

    var productImageIdentity = normalizedImageIdentity(productImage);
    var productImageColor = imageColorToken(productImage);

    var match = null;

    if (activeFilterColor) {
      match = colors.find(function (color) {
        return normalizedColorToken(color.name) === activeFilterColor;
      });
      if (match) return match;
    }

    if (explicitStyleId) {
      match = colors.find(function (color) {
        return String(color.styleId || "") === explicitStyleId;
      });
      if (match) return match;
    }

    if (explicitColorName) {
      match = colors.find(function (color) {
        return normalizedColorToken(color.name) === explicitColorName;
      });
      if (match) return match;
    }

    if (productImageIdentity) {
      match = colors.find(function (color) {
        return normalizedImageIdentity(color.imageUrl) === productImageIdentity;
      });
      if (match) return match;
    }

    if (productImageColor) {
      match = colors.find(function (color) {
        return normalizedColorToken(color.name) === productImageColor;
      });
      if (match) return match;
    }

    return colors[0] || null;
  }

  function compareList(values, key) {
    if (!Array.isArray(values)) return [];

    return values
      .map(function (item) {
        if (item == null) return "";

        if (typeof item === "string" || typeof item === "number") {
          return String(item).trim();
        }

        return String(
          key && item[key] != null
            ? item[key]
            : item.name != null
              ? item.name
              : item.label != null
                ? item.label
                : item.value != null
                  ? item.value
                  : ""
        ).trim();
      })
      .filter(Boolean);
  }

  function compareColorPayload(colors) {
    if (!Array.isArray(colors)) return [];

    return colors.map(function (color) {
      return {
        name: String(color && color.name || "").trim(),
        hex1: String(color && color.hex1 || "").trim(),
        hex2: String(color && color.hex2 || "").trim()
      };
    }).filter(function (color) {
      return !!color.name;
    });
  }

  function compareProductPayload(product, initialColor, initialImageUrl) {
    var colors = compareColorPayload(product.colors || []);
    var sizes = compareList(
      product.sizes ||
      product.availableSizes ||
      product.sizeOptions ||
      []
    );

    return {
      id: String(product.id || ""),
      name: String(product.name || ""),
      brand: String(product.brand || ""),
      sku: String(
        product.sku ||
        product.Sku ||
        product.productSku ||
        product.ProductSku ||
        ""
      ),
      manufacturerSku: String(
        product.manufacturerSku ||
        product.manufacturerSKU ||
        product.ManufacturerSku ||
        product.ManufacturerSKU ||
        ""
      ),
      imageUrl: String(initialImageUrl || product.thumbnailUrl || ""),
      selectedColor: String(
        initialColor && initialColor.name
          ? initialColor.name
          : ""
      ),
      colorCount: Number(
        product.colorCount ||
        colors.length ||
        0
      ),
      colors: colors,
      sizes: sizes,
      description: String(
        product.description ||
        product.Description ||
        product.productDescription ||
        product.ProductDescription ||
        product.details ||
        product.Details ||
        ""
      ).trim()
    };
  }

  function cardHtml(state, product) {
    var colors = Array.isArray(product.colors) ? product.colors : [];
    var initialColor = getInitialColor(state, product, colors);
    var visibleColors = colors.slice(0, 8);

    if (
      initialColor &&
      visibleColors.indexOf(initialColor) === -1 &&
      visibleColors.length
    ) {
      visibleColors[visibleColors.length - 1] = initialColor;
    }

    var url = productUrl(state, product, initialColor);

    /*
      Keep the visible card image, selected swatch, and generated detail link
      tied to the same color object. The summary thumbnail can represent a
      different InkSoft style than colors[0], which caused the visual mismatch.
    */
    var initialImageUrl =
      initialColor && initialColor.imageUrl
        ? initialColor.imageUrl
        : product.thumbnailUrl || "";

    var comparePayload = compareProductPayload(
      product,
      initialColor,
      initialImageUrl
    );

    var image = initialImageUrl
      ? [
          '<img',
          ' class="ua-catalog__image"',
          ' src="' + escapeHtml(initialImageUrl) + '"',
          ' alt="' + escapeHtml(product.name) + '"',
          ' loading="lazy"',
          ' decoding="async"',
          ' width="500"',
          ' height="500"',
          ' data-ua-catalog-card-image',
          '>'
        ].join("")
      : "";

    var swatches = visibleColors.map(function (color, index) {
      var imageUrl = color.imageUrl || "";
      var selected = color === initialColor;
      var common = [
        ' class="ua-catalog__swatch' + (selected ? ' is-selected' : '') + '"',
        ' title="' + escapeHtml(color.name) + '"',
        ' aria-label="Show ' + escapeHtml(product.name) + ' in ' + escapeHtml(color.name) + '"',
        ' style="' + swatchStyle(color) + '"'
      ].join("");

      if (!imageUrl) {
        return '<span' + common + ' aria-hidden="true"></span>';
      }

      return [
        '<button',
        common,
        ' type="button"',
        ' data-ua-catalog-swatch',
        ' data-image-url="' + escapeHtml(imageUrl) + '"',
        ' data-color-name="' + escapeHtml(color.name) + '"',
        ' data-style-id="' + escapeHtml(color.styleId || "") + '"',
        ' aria-pressed="' + (selected ? "true" : "false") + '"',
        '></button>'
      ].join("");
    }).join("");

    var moreCount = Math.max(
      0,
      Number(product.colorCount || colors.length || 0) - visibleColors.length
    );

    var more = moreCount > 0
      ? '<div class="ua-catalog__more-colors">+' + moreCount + ' more colors</div>'
      : "";

    return [
      '<article',
      ' class="ua-catalog__card"',
      ' data-ua-catalog-card',
      ' data-product-id="' + escapeHtml(product.id) + '"',
      '>',
        '<a class="ua-catalog__image-link" href="' + escapeHtml(url) + '" aria-label="View ' + escapeHtml(product.name) + '">',
          '<div class="ua-catalog__image-wrap">',
            productBadgeHtml(product),
            image,
          '</div>',
        '</a>',
        '<div class="ua-catalog__card-body">',
          '<div class="ua-catalog__compare-control">',
            '<button',
            ' class="ua-catalog__compare-button"',
            ' type="button"',
            ' data-ua-catalog-compare',
            ' data-compare-product="' + escapeHtml(JSON.stringify(comparePayload)) + '"',
            ' aria-pressed="false"',
            '><span class="ua-catalog__compare-box" aria-hidden="true"></span>',
            '<span>Compare apparel</span></button>',
          '</div>',
          product.brand ? '<p class="ua-catalog__brand">' + escapeHtml(product.brand) + '</p>' : '', 
          '<h2 class="ua-catalog__product-name">',
            '<a href="' + escapeHtml(url) + '">' + escapeHtml(product.name) + '</a>',
          '</h2>',
          colors.length
            ? '<div class="ua-catalog__swatches" aria-label="Available colors">' + swatches + '</div>'
            : '',
          more,
        '</div>',
      '</article>'
    ].join("");
  }

  function setSelectOptions(select, items, firstLabel, selectedValue) {
    var html = '<option value="">' + escapeHtml(firstLabel) + '</option>';

    items.forEach(function (item) {
      var selected = item === selectedValue ? " selected" : "";
      html += '<option value="' + escapeHtml(item) + '"' + selected + '>' + escapeHtml(item) + '</option>';
    });

    select.innerHTML = html;
  }


  var CATEGORY_NAME_OVERRIDES = {
    "Polos Shirts": "Polo Shirts",
    "Mens' Sweatshirts": "Men’s Sweatshirts",
    "Men's T-shirt": "Men’s T-Shirts"
  };

  var PE_UNIFORMS_GROUP_ID = "__UA_PE_UNIFORMS__";
  var SPORTS_WEAR_GROUP_ID = "__UA_SPORTS_WEAR__";

  function categoryDisplayName(name) {
    return CATEGORY_NAME_OVERRIDES[name] || name;
  }

  function isPeUniformCategory(node) {
    var name = String(node && node.name || "")
      .trim()
      .toLowerCase();

    return (
      name === "pe" ||
      name.indexOf("pe ") === 0 ||
      name.indexOf("p.e. ") === 0 ||
      name.indexOf("physical education") === 0
    );
  }

  function groupPeUniformCategories(categories) {
    var peCategories = [];
    var otherCategories = [];

    (Array.isArray(categories) ? categories : []).forEach(function (node) {
      if (isPeUniformCategory(node)) {
        peCategories.push(node);
      } else {
        otherCategories.push(node);
      }
    });

    if (!peCategories.length) {
      return { peGroup: null, categories: otherCategories };
    }

    var peCount = peCategories.reduce(function (total, node) {
      return total + Number(node && node.itemCount || 0);
    }, 0);

    return {
      peGroup: {
        id: PE_UNIFORMS_GROUP_ID,
        name: "PE Uniforms",
        itemCount: peCount,
        children: peCategories,
        groupOnly: true
      },
      categories: otherCategories
    };
  }

  function isSportsWearCategory(node) {
    var name = String(node && node.name || "")
      .trim()
      .toLowerCase();

    if (!name || isPeUniformCategory(node)) return false;

    /*
     * Sports Wear is intentionally based on a named sport, not on generic
     * apparel words such as tees, shorts, jerseys, or sweatshirts. This keeps
     * ordinary catalogue categories in their existing positions while moving
     * categories such as Flag Football Tees, Basketball Shorts, and Soccer
     * Jerseys under one umbrella.
     */
    var sportPatterns = [
      /\bflag\s+football\b/,
      /\bbasketball\b/,
      /\bsoccer\b/,
      /\bvolleyball\b/,
      /\bbaseball\b/,
      /\bsoftball\b/,
      /\bfootball\b/,
      /\blacrosse\b/,
      /\bwrestling\b/,
      /\btennis\b/,
      /\bgolf\b/,
      /\bcheer(?:leading)?\b/,
      /\bhockey\b/,
      /\bswim(?:ming)?\b/,
      /\btrack(?:\s+and\s+field|\s*&\s*field)?\b/,
      /\bcross\s+country\b/,
      /\besports?\b/
    ];

    return sportPatterns.some(function (pattern) {
      return pattern.test(name);
    });
  }

  function groupSportsWearCategories(categories) {
    var sportsCategories = [];
    var otherCategories = [];

    (Array.isArray(categories) ? categories : []).forEach(function (node) {
      if (isSportsWearCategory(node)) {
        sportsCategories.push(node);
      } else {
        otherCategories.push(node);
      }
    });

    if (!sportsCategories.length) {
      return { sportsGroup: null, categories: otherCategories };
    }

    var sportsCount = sportsCategories.reduce(function (total, node) {
      return total + Number(node && node.itemCount || 0);
    }, 0);

    return {
      sportsGroup: {
        id: SPORTS_WEAR_GROUP_ID,
        name: "Sports Wear",
        itemCount: sportsCount,
        children: sportsCategories,
        groupOnly: true
      },
      categories: otherCategories
    };
  }

  function specialtyCategoryLink(label, href) {
    return [
      '<a class="ua-catalog__category-button ua-catalog__category-button--specialty"',
      ' href="' + escapeHtml(href) + '"',
      ' style="text-decoration:none;"',
      '>',
      '<span>' + escapeHtml(label) + '</span>',
      '<span aria-hidden="true">→</span>',
      '</a>'
    ].join("");
  }

  function categoryContainsId(node, categoryId) {
    if (String(node.id) === String(categoryId)) return true;

    return (node.children || []).some(function (child) {
      return categoryContainsId(child, categoryId);
    });
  }

  function categoryButton(node, state, depth) {
    var activeId = state.filters.categoryId;
    var active =
      !state.filters.tag &&
      String(node.id) === String(activeId);
    var count = Number(node.itemCount || 0);
    var children = Array.isArray(node.children) ? node.children : [];
    var hasChildren = children.length > 0;
    var selectedBranch = hasChildren && categoryContainsId(node, activeId);
    var storedExpansion =
      Object.prototype.hasOwnProperty.call(
        state.expandedCategoryIds,
        String(node.id)
      )
        ? state.expandedCategoryIds[String(node.id)]
        : null;

    /*
     * A selected child normally opens its parent branch, but an explicit
     * false value must still allow the user to collapse that branch.
     */
    var expanded = hasChildren && (
      storedExpansion === true ||
      (storedExpansion !== false && selectedBranch)
    );
    var childId = "UaCategoryChildren-" + String(node.id).replace(/[^a-zA-Z0-9_-]/g, "");

    var html = '<div class="ua-catalog__category-row" style="--ua-category-depth:' + depth + '">';

    if (hasChildren) {
      html += [
        '<button class="ua-catalog__category-expand" type="button"',
        ' data-category-toggle="' + escapeHtml(node.id) + '"',
        ' aria-expanded="' + (expanded ? "true" : "false") + '"',
        ' aria-controls="' + escapeHtml(childId) + '"',
        ' aria-label="' + (expanded ? "Collapse " : "Expand ") + escapeHtml(categoryDisplayName(node.name)) + '">',
        '<span aria-hidden="true">' + (expanded ? "−" : "+") + '</span>',
        '</button>'
      ].join("");
    } else {
      html += '<span class="ua-catalog__category-expand-spacer" aria-hidden="true"></span>';
    }

    html += [
      '<button class="ua-catalog__category-button' + (active ? ' is-active' : '') + '"',
      ' type="button"',
      node.groupOnly
        ? ' data-category-toggle="' + escapeHtml(node.id) + '"'
        : ' data-category-id="' + escapeHtml(node.id) + '"',
      node.groupOnly
        ? ' aria-expanded="' + (expanded ? "true" : "false") + '"'
        : (active ? ' aria-current="page"' : ''),
      '>',
      '<span>' + escapeHtml(categoryDisplayName(node.name)) + '</span>',
      count > 0 ? '<small>' + count + '</small>' : '',
      '</button>',
      '</div>'
    ].join("");

    if (hasChildren) {
      html += '<div id="' + escapeHtml(childId) + '" class="ua-catalog__category-children"' +
        (expanded ? '' : ' hidden') + '>' +
        children.map(function (child) {
          return categoryButton(child, state, depth + 1);
        }).join("") +
      '</div>';
    }

    return html;
  }


  window.UA_CATALOG.render = {
    categories: function categories(state) {
      var wrap = state.root.querySelector("[data-ua-catalog-categories]");
      if (!wrap) return;

      var allActive =
        !state.filters.tag &&
        (!state.filters.categoryId || state.filters.categoryId === "ALL");
      var peGrouping = groupPeUniformCategories(state.categories || []);
      var sportsGrouping = groupSportsWearCategories(peGrouping.categories);
      var html = "";

      /*
       * PE and Sports are now dedicated storefront destinations rather than
       * filters inside the regular catalog grid.
       *
       * Their underlying category branches are still removed from the normal
       * category list by groupPeUniformCategories/groupSportsWearCategories,
       * but these two top-level entries navigate to their dedicated pages.
       */
      if (peGrouping.peGroup) {
        html += specialtyCategoryLink(
          "PE Uniforms",
          "/pages/pe-uniforms"
        );
      }

      if (sportsGrouping.sportsGroup) {
        html += specialtyCategoryLink(
          "Sports Apparel",
          "/pages/sports-apparel"
        );
      }

      html += [
        '<button class="ua-catalog__category-button' + (allActive ? ' is-active' : '') + '"',
        ' type="button" data-category-id="ALL"',
        allActive ? ' aria-current="page"' : '',
        '><span>All Products</span></button>'
      ].join("");

      html += sportsGrouping.categories.map(function (node) {
        return categoryButton(node, state, 0);
      }).join("");

      wrap.innerHTML = html;
    },

    skeletons: function skeletons(state) {
      var root = state.root;
      var grid = root.querySelector("[data-ua-catalog-grid]");
      var empty = root.querySelector("[data-ua-catalog-empty]");
      var results = root.querySelector("[data-ua-catalog-results]");
      var pagination = root.querySelector("[data-ua-catalog-pagination]");
      var cards = [];

      if (empty) empty.hidden = true;
      if (results) results.textContent = "Loading products...";
      if (pagination) pagination.hidden = true;

      for (var i = 0; i < state.pageSize; i += 1) {
        cards.push(
          '<div class="ua-catalog__skeleton" aria-hidden="true">' +
            '<div class="ua-catalog__skeleton-block ua-catalog__skeleton-image"></div>' +
            '<div class="ua-catalog__skeleton-block ua-catalog__skeleton-line"></div>' +
            '<div class="ua-catalog__skeleton-block ua-catalog__skeleton-line"></div>' +
          '</div>'
        );
      }

      grid.innerHTML = cards.join("");
      grid.setAttribute("aria-busy", "true");
    },

    loadingState: function loadingState(state, loading) {
      var root = state.root;
      var previous = root.querySelector("[data-ua-catalog-previous]");
      var next = root.querySelector("[data-ua-catalog-next]");
      var grid = root.querySelector("[data-ua-catalog-grid]");

      if (grid) {
        grid.setAttribute("aria-busy", loading ? "true" : "false");
      }

      if (previous) {
        previous.disabled = loading || state.page <= 1;
      }

      if (next) {
        if (loading) {
          if (!next.hasAttribute("data-default-label")) {
            next.setAttribute(
              "data-default-label",
              next.textContent || "Next"
            );
          }

          next.textContent = "Loading...";
          next.disabled = true;
        } else {
          next.textContent =
            next.getAttribute("data-default-label") || "Next";
        }
      }
    },

    response: function response(state, payload) {
      var root = state.root;
      var grid = root.querySelector("[data-ua-catalog-grid]");
      var empty = root.querySelector("[data-ua-catalog-empty]");
      var results = root.querySelector("[data-ua-catalog-results]");
      var pagination = root.querySelector("[data-ua-catalog-pagination]");
      var previous = root.querySelector("[data-ua-catalog-previous]");
      var next = root.querySelector("[data-ua-catalog-next]");
      var pageLabel = root.querySelector("[data-ua-catalog-page-label]");

      if (next) {
        next.textContent =
          next.getAttribute("data-default-label") || "Next";
      }

      state.total = Number(payload.total || 0);

      var effectivePageSize = Math.max(
        1,
        Number(payload.pageSize || state.pageSize || 12)
      );

      var calculatedTotalPages = state.total > 0
        ? Math.ceil(state.total / effectivePageSize)
        : 0;

      state.totalPages = calculatedTotalPages;
      state.currentResponse = payload;

      grid.innerHTML = (payload.products || []).map(function (product) {
        return cardHtml(state, product);
      }).join("");

      grid.setAttribute("aria-busy", "false");
      empty.hidden = state.total !== 0;
      results.textContent = state.total === 1
        ? "1 product"
        : state.total + " products";

      if (state.totalPages <= 1 || state.total <= effectivePageSize) {
        pagination.hidden = true;
        previous.disabled = true;
        next.disabled = true;
        pageLabel.textContent = "Page 1 of 1";
      } else {
        var currentPage = Math.min(
          Math.max(1, Number(payload.page || state.page || 1)),
          state.totalPages
        );

        pagination.hidden = false;
        previous.disabled = currentPage <= 1;
        next.disabled = currentPage >= state.totalPages;
        pageLabel.textContent =
          "Page " + currentPage + " of " + state.totalPages;
      }

      var filters = payload.availableFilters || {};
      setSelectOptions(
        root.querySelector("[data-ua-catalog-brand]"),
        filters.brands || [],
        "All brands",
        state.filters.brand
      );
      setSelectOptions(
        root.querySelector("[data-ua-catalog-color]"),
        filters.colors || [],
        "All colors",
        state.filters.color
      );
      setSelectOptions(
        root.querySelector("[data-ua-catalog-size]"),
        filters.sizes || [],
        "All sizes",
        state.filters.size
      );
    },

    error: function error(state, message) {
      var root = state.root;
      var grid = root.querySelector("[data-ua-catalog-grid]");
      var results = root.querySelector("[data-ua-catalog-results]");
      var pagination = root.querySelector("[data-ua-catalog-pagination]");

      grid.innerHTML = "";
      grid.setAttribute("aria-busy", "false");
      results.textContent = message || "Unable to load products.";
      pagination.hidden = true;
    }
  };
})();